var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15957 11.8673C9.05957 11.8573 8.93957 11.8573 8.82957 11.8673C6.44957 11.7873 4.55957 9.83731 4.55957 7.43731C4.55957 4.98731 6.53957 2.99731 8.99957 2.99731C11.4496 2.99731 13.4396 4.98731 13.4396 7.43731C13.4296 9.83731 11.5396 11.7873 9.15957 11.8673Z",
    stroke: "#D96122",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4103 4.99731C18.3503 4.99731 19.9103 6.56731 19.9103 8.49731C19.9103 10.3873 18.4103 11.9273 16.5403 11.9973C16.4603 11.9873 16.3703 11.9873 16.2803 11.9973",
    stroke: "#D96122",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15973 15.5573C1.73973 17.1773 1.73973 19.8173 4.15973 21.4273C6.90973 23.2673 11.4197 23.2673 14.1697 21.4273C16.5897 19.8073 16.5897 17.1673 14.1697 15.5573C11.4297 13.7273 6.91973 13.7273 4.15973 15.5573Z",
    stroke: "#D96122",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3398 20.9973C19.0598 20.8473 19.7398 20.5573 20.2998 20.1273C21.8598 18.9573 21.8598 17.0273 20.2998 15.8573C19.7498 15.4373 19.0798 15.1573 18.3698 14.9973",
    stroke: "#D96122",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCard);
export default __webpack_public_path__ + "static/media/user-card.501946753b4fefde4d4357fa89f7dfc5.svg";
export { ForwardRef as ReactComponent };